<div class="discuss-and-demonstrate"
     data-testid="discuss-demonstrate-container">
  <schedule-detail-header [title]="headerTitle()"
                          [subtitle]="subtitle()"
                          [backCallback]="goBack.bind(this)"
                          [showCloud]="true"></schedule-detail-header>
  @if (!dataLoaded()) {
    <div class="skeleton-content"
         data-testid="discuss-demonstrate-skeleton">
      <p-skeleton height="2rem"
                  width="10rem"></p-skeleton>
      <p-skeleton height="15rem"></p-skeleton>
      <p-skeleton height="15rem"></p-skeleton>
    </div>
  } @else {
    <tab-bar [options]="tabOptions"
             [initialValue]="currentTab()"
             (onTabChanged)="changeTab($event)"
             data-testid="discuss-demonstrate-tab-buttons">
      <ng-template let-option>
        @if (option.value === Tab.Items) {
          <span>Items</span> <span class="items-count">({{ openIssues().length }})</span>
        } @else {
          {{ option.label }}
        }
      </ng-template>
    </tab-bar>
    <div class="tab-content"
         data-testid="discuss-demonstrate-tab-content">
      @if (currentTab() === Tab.Items) {
        <app-punchlist [dataLoaded]="dataLoaded()"
                       [areaNames]="areaNames()"
                       [issuesByArea]="issuesByArea()"
                       [newIssueId]="newIssueId()"
                       [imagesOfIssue]="imagesOfIssue()"
                       [vendorOfIssue]="vendorOfIssue()"
                       [disableEditing]="false"
                       [isReviewIssuesView]="true"
                       (editIssue)="openDrawer($event.issue)"
                       (viewImage)="openImagesModal($event.issueId, $event.imageIndex)">
        </app-punchlist>
      } @else {
        <app-checklist [touched]="touched()"
                       [checklistGroups]="checklistGroups()"
                       [persistItemToggle]="persistChecklistItemToggle.bind(this)"
                       (complete)="updateChecklistStatus($event)" />
      }
    </div>
    <div class="discuss-and-demonstrate-footer"
         data-testid="discuss-demonstrate-footer">
      <button class="button"
              (click)="openDrawer()"
              data-testid="discuss-demonstrate-btn-new-item">
        <i class="pi pi-plus new-item-icon"></i>
        New Item
      </button>
      <button (click)="navigateToFinalReview()"
              class="button final-review"
              data-testid="discuss-demonstrate-btn-final-review">
        Final Review
      </button>
    </div>
  }
</div>
<app-discuss-and-demonstrate-issue-drawer [isOpen]="addingIssue()"
                                          (isOpenChange)="addingIssue.set($event)"
                                          [issue]="issueBeingEdited()"
                                          [initialLotAreaIdentifier]="issueDrawerInitialLotAreaIdentifier()"
                                          (saved)="handleIssueSaved($event)"
                                          (closed)="closeDrawer()"
                                          (deleted)="handleIssueDeleted()">
</app-discuss-and-demonstrate-issue-drawer>